import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { formatString } from './format-string';
import { isTruthy, isNumber, isInteger, isDefined } from './validators';
import { isLength as _isLength, isEmail as _isEmail, isPostalCode as _isPostalCode, isMobilePhone, isNumeric, isURL, isCurrency as _isCurrency, equals as _equals } from 'validator';
var makeValidator = function makeValidator(fn, message) {
  return function (options, customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      if (value === undefined) return undefined;
      var pass = fn(value, options);
      return pass ? undefined : formatString(customMessage ? customMessage : message, {
        name: name
      });
    };
  };
};
export var validate = function validate(validators, name) {
  return function (value, values) {
    var errorArray = validators.reduce(function (errors, validator) {
      var error = name !== undefined ? validator(value, values, name) : validator(value, values);
      if (error !== undefined) errors.push(error);
      return errors;
    }, []);
    return errorArray.length > 0 ? errorArray[0] : undefined;
  };
};
export var validators = {
  isRequired: function isRequired() {
    var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var customMessage = arguments.length > 1 ? arguments[1] : undefined;
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      var defaultMessage = '{name} is required';
      if (!when) return undefined;
      return isTruthy(value) ? undefined : formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  },
  isRequiredWhen: function isRequiredWhen(opts, customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      var defaultMessage = '{name} is required';
      var isRequired = false;
      if (isDefined(opts.isSet)) {
        isRequired = isDefined(values[opts.field]) == opts.isSet;
      } else if (isDefined(opts.field)) {
        isRequired = values[opts.field] === opts.equals;
      }
      if (!isRequired) return undefined;
      return isTruthy(value) ? undefined : formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  },
  isNumeric: makeValidator(isNumeric, '{name} must be a number'),
  isLength: function isLength(options, customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      var opts = _objectSpread({
        min: 0
      }, options);
      var convertedValue = value + '';
      var defaultMessage = '';
      if (value === undefined) return undefined;
      if (isDefined(opts.min) && isDefined(opts.max) && opts.min > opts.max) return undefined;
      var pass = _isLength(convertedValue.trim(), opts);
      if (pass) return undefined;
      if (opts.max === opts.min) {
        defaultMessage = "{name} must be ".concat(opts.min, " character") + (opts.min > 1 ? 's' : '');
      } else if (opts.max && opts.min) {
        defaultMessage = "{name} must be between ".concat(opts.min, " and ").concat(opts.max, " characters");
      } else if (opts.min) {
        defaultMessage = "{name} must be at least ".concat(opts.min, " character") + (opts.min > 1 ? 's' : '');
      } else if (opts.max) {
        defaultMessage = "{name} must be less than ".concat(opts.max, " character") + (opts.max > 1 ? 's' : '');
      }
      return formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  },
  equals: function equals(comparison, customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      if (value === undefined) return undefined;
      var defaultMessage = "{name} does not match \"".concat(comparison, "\"");
      return _equals(value, comparison) ? undefined : formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  },
  oneOf: function oneOf(comparison, customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      if (value === undefined) return undefined;
      var defaultMessage = "{name} must be one of ".concat(comparison.join(', '));
      return comparison.includes(value) ? undefined : formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  },
  notOneOf: function notOneOf(comparison, customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      if (value === undefined) return undefined;
      var defaultMessage = "{name} cannot be one of ".concat(comparison.join(', '));
      return comparison.includes(value) ? formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      }) : undefined;
    };
  },
  isNumber: makeValidator(isNumber, '{name} is not a number'),
  isInteger: makeValidator(isInteger, '{name} must be an integer'),
  inRange: function inRange(options, customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      if (value === undefined) return undefined;
      var parsedValue = Number(value);
      if (isNaN(parsedValue)) return formatString("{name} must be a number", {
        name: name
      });
      var pass = true;
      var defaultMessage = '';
      if (options.min !== undefined && value < options.min) {
        pass = false;
      } else if (options.max !== undefined && value > options.max) {
        pass = false;
      }
      if (options.max !== undefined && options.min !== undefined) {
        defaultMessage = "{name} must be between ".concat(options.min, " and ").concat(options.max);
      } else if (options.min !== undefined) {
        defaultMessage = "{name} must be ".concat(options.min, " or greater");
      } else if (options.max !== undefined) {
        defaultMessage = "{name} must be less than ".concat(options.max);
      }
      return pass ? undefined : formatString(!!customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  },
  isEmail: function isEmail(customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      if (value === undefined) return undefined;
      var defaultMessage = '{name} must be a valid email';
      return _isEmail(value + '') ? undefined : formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  },
  isPhone: function isPhone(options, customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      if (value === undefined) return undefined;
      var defaultMessage = '{name} must be a valid phone number';
      return isMobilePhone(value + '', 'en-US', options) ? undefined : formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  },
  isPostalCode: function isPostalCode(customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      if (value === undefined) return undefined;
      var convertedValue = value + '';
      var defaultMessage = '{name} must be a valid Postal Code';
      return _isPostalCode(convertedValue, 'US') ? undefined : formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  },
  isUrl: function isUrl(options, customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      if (value === undefined) return undefined;
      var defaultMessage = '{name} must be a valid Url';
      return isURL(value, options) ? undefined : formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  },
  isCurrency: function isCurrency(options, customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      if (value === undefined) return undefined;
      var defaultMessage = '{name} must be a valid price';
      return _isCurrency(value + '', options) ? undefined : formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  },
  matches: function matches(field, customMessage) {
    return function (value, values) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'This field';
      if (value === undefined || values[field] === undefined) return undefined;
      var defaultMessage = "{name} does not match ".concat(field);
      return value === values[field] ? undefined : formatString(customMessage ? customMessage : defaultMessage, {
        name: name
      });
    };
  }
};